import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// The Suite app has no offline/PWA requirement, and a service worker here
// previously caused a confirmed staleness bug (2026-09-04): see
// src/serviceWorkerRegistration.ts and src/service-worker.ts for why this
// calls unregister() rather than register().
serviceWorkerRegistration.unregister();
